import { c as _c } from "react/compiler-runtime";
import { catchError } from "next/error";
import { Suspense } from "react";
import { RegistrarLinks, RegistrarLinksSkeleton } from "@/components/domain/registrar-links";
import { Card } from "@domainstack/ui/card";

// Renders nothing on error; used for supplementary info like pricing.
const SilentErrorBoundary = catchError(() => null);
interface DomainUnregisteredCardProps {
  domain: string;
  /** TLD to show registrar pricing for; null when the TLD isn't publicly registrable. */
  pricingTld: string | null;
}
export function DomainUnregisteredCard(t0) {
  const $ = _c(12);
  const {
    domain,
    pricingTld
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-hidden={true} className="pointer-events-none absolute -inset-x-35 -top-35 h-85 glow-accent-indigo/15" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== domain) {
    t2 = <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">{domain}</h2>;
    $[1] = domain;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="mt-2 text-sm text-muted-foreground sm:text-base">appears to be unregistered…</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div>{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== domain || $[7] !== pricingTld) {
    t5 = pricingTld && <SilentErrorBoundary><Suspense fallback={<RegistrarLinksSkeleton />}><RegistrarLinks domain={domain} tld={pricingTld} /></Suspense></SilentErrorBoundary>;
    $[6] = domain;
    $[7] = pricingTld;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Card className="relative overflow-hidden px-6 text-center">{t1}<div className="relative space-y-4.5">{t4}{t5}</div></Card>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}